import React, { ComponentProps } from "react";
import { Image } from "react-bootstrap";

import "./NotificationButton.scss";
import ImageBellIcon from "../../../images/bell-icon-black.svg";
import DownloadAppPrompt, {
  PROMPT_DOWNLOAD_SCENARIOS,
} from "../../DownloadAppPrompt/DownloadAppPrompt";
import useDisclosure from "../../../hooks/useDisclosure";

interface NotificationButtonProps extends ComponentProps<"button"> {
  hasNotifications?: boolean;
}

function NotificationButton({
  hasNotifications,
  className = "",
  ...restProps
}: NotificationButtonProps) {
  const {
    isOpen: isDownloadAppPromptOpen,
    onOpen: openDownloadAppPrompt,
    onClose: closeDownloadAppPrompt,
  } = useDisclosure();

  const handleActivitiesClick = () => {
    openDownloadAppPrompt();
  };

  return (
    <>
      <button
        aria-label="view notifications"
        className="notification-btn"
        onClick={handleActivitiesClick}
        {...restProps}
      >
        {hasNotifications && <span className="indicator" />}
        <Image src={ImageBellIcon} alt="bell" />
      </button>

      <DownloadAppPrompt
        isOpen={isDownloadAppPromptOpen}
        onOpen={openDownloadAppPrompt}
        onClose={closeDownloadAppPrompt}
        promptDownloadScenario={PROMPT_DOWNLOAD_SCENARIOS.LOGGED_IN.OTHERS}
      />
    </>
  );
}

export default NotificationButton;
